import Center from '../../assets/styles/Center';
import Banner from './components/Banner';
import Filter from './components/Filter';
import Imgs from './components/Imgs';
import * as styles from './styles';

export default function Home() {
  return (
    <styles.Container>
      <Center>
        <Banner />
        {/* <Models /> */}
        <Imgs />
        <Filter />
      </Center>
    </styles.Container>
  );
}
